var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$store.state.supportedCultures.length > 1
    ? _c(
        "v-menu",
        {
          attrs: { bottom: "", left: "", "offset-y": "" },
          scopedSlots: _vm._u(
            [
              {
                key: "activator",
                fn: function (ref) {
                  var on = ref.on
                  return [
                    _c(
                      "v-btn",
                      _vm._g(
                        {
                          staticClass: "mr-2",
                          attrs: {
                            dark: "",
                            icon: "",
                            small: "",
                            "aria-label": _vm.btnAriaLabelLanguage,
                          },
                        },
                        on
                      ),
                      [_c("v-img", { attrs: { src: _vm.langImageUrl } })],
                      1
                    ),
                  ]
                },
              },
            ],
            null,
            false,
            4272817780
          ),
        },
        [
          _vm._v(" "),
          _c(
            "v-list",
            _vm._l(_vm.$store.state.supportedCultures, function (item, index) {
              return _c("culture-selector-item", {
                key: item.name,
                attrs: { culture: item },
                on: { click: _vm.selectLanguage },
              })
            }),
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }